// @ts-nocheck
import {FC} from 'react'
import {ColumnInstance} from 'react-table'
import {MeasuringBox} from '../../core/_models'
import {TOKENS} from '../../../../../../components/design-system'

type Props = {
  column: ColumnInstance<MeasuringBox>
}

const baseHeader: React.CSSProperties = {
  padding: '18px 20px',
  backgroundColor: TOKENS.color.surfaceStrong,
  borderBottom: `1px solid ${TOKENS.color.border}`,
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: 0.8,
  textTransform: 'uppercase',
  color: '#334155',
  whiteSpace: 'nowrap',
  verticalAlign: 'middle',
}

const CustomHeaderColumn: FC<Props> = ({column}) => {
  const isActions = column.id === 'actions'
  const style: React.CSSProperties = { ...baseHeader, textAlign: isActions ? 'right' : 'left' }
  return (
    <>
      {column.Header && typeof column.Header === 'string' ? (
        <th {...column.getHeaderProps()} style={style}>{column.render('Header')}</th>
      ) : (
        column.render('Header')
      )}
    </>
  )
}

export {CustomHeaderColumn}
